export default __webpack_public_path__ + "static/media/succulent1.2a95bd85.jpg";